import { getValueBatterColumns, getValuePitcherColumns, columnsValueBattingTeam, columnsValuePitchingTeam } from "./columns/value";
import { getSituationalBatterColumns, getSituationalPitcherrColumns, getSituationalBattingTeamColumns, getSituationalPitchingTeamColumns } from "./columns/situational";
import { getSplitsBatterColumns, getSplitsPitcherColumns, getSplitsBattingTeamColumns, getSplitsPitchingTeamColumns } from "./columns/splits";
import { getBaserunningColumns, getBaserunningTeamColumns } from "./columns/baserunning";
import { getBattedBallBatterColumns, getBattedBallPitcherColumns, getBattedBallBattingTeamColumns, getBattedBallPitchingTeamColumns } from "./columns/batted-ball";

export { getValueBatterColumns, getValuePitcherColumns, columnsValueBattingTeam, columnsValuePitchingTeam } from "./columns/value";
export { getSituationalBatterColumns, getSituationalPitcherrColumns, getSituationalBattingTeamColumns, getSituationalPitchingTeamColumns } from "./columns/situational";
export {
  getSplitsBatterColumns,
  getSplitsPitcherColumns,
  getSplitsBattingTeamColumns,
  getSplitsPitchingTeamColumns,
  getSplitsScoutingPrintFields,
  splitsBatterStatFieldDefs,
  splitsPitcherStatFieldDefs,
} from "./columns/splits";
export { getBaserunningColumns, getBaserunningTeamColumns } from "./columns/baserunning";
export { getBattedBallBatterColumns, getBattedBallPitcherColumns, getBattedBallBattingTeamColumns, getBattedBallPitchingTeamColumns } from "./columns/batted-ball";

const COLUMN_MAP = {
  value: {
    player: { batter: getValueBatterColumns, pitcher: getValuePitcherColumns },
    team: { batter: columnsValueBattingTeam, pitcher: columnsValuePitchingTeam },
  },
  situational: {
    player: { batter: getSituationalBatterColumns, pitcher: getSituationalPitcherrColumns },
    team: { batter: getSituationalBattingTeamColumns, pitcher: getSituationalPitchingTeamColumns },
  },
  splits: {
    player: { batter: getSplitsBatterColumns, pitcher: getSplitsPitcherColumns },
    team: { batter: getSplitsBattingTeamColumns, pitcher: getSplitsPitchingTeamColumns },
  },
  baserunning: {
    player: getBaserunningColumns,
    team: getBaserunningTeamColumns,
  },
  battedball: {
    player: { batter: getBattedBallBatterColumns, pitcher: getBattedBallPitcherColumns },
    team: { batter: getBattedBallBattingTeamColumns, pitcher: getBattedBallPitchingTeamColumns },
  },
};

export const getLeaderboardColumns = (type, playerType, viewLevel) => {
  const config = COLUMN_MAP[type];
  if (!config) return getValueBatterColumns;
  const level = config[viewLevel] || config.player;
  if (Array.isArray(level)) return level;
  return level[playerType] || level.batter;
};
